import React from "react";
import iconUp from "./iconUp.png";

const style = () => ({
  padding: "0.5em",
  borderRadius: "5px",
  backgroundColor: "white",
  boxShadow: "1px 2px 10px black",
  bottom: 10,
  right: 10,
  position: "fixed" as "fixed"
});

const Up = () => {
  return (
    <a style={style()} href="#nav">
      <img src={iconUp} alt="Up"></img>
    </a>
  );
};

export default Up;
